import { parse } from "date-fns";

/**
 * Parses a YYYY-MM-DD date string into a Date object via date-fns/parse.
 * @param date A date string in the format YYYY-MM-DD
 */
export const parseDate = (date: string): Date => {
  return parse(date, "yyyy-MM-dd", new Date());
};
